var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_812",
    "data-name": "Rectangle 812",
    width: 70,
    height: 70,
    transform: "translate(1182 1303)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_66",
    "data-name": "Mask Group 66",
    transform: "translate(-1182 -1303)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "warning_FILL0_wght400_GRAD0_opsz48",
    d: "M40,234.317,73.763,176l33.763,58.317Zm7.98-4.6H99.545L73.763,185.208Zm26.1-4.374a2.2,2.2,0,0,0,1.636-.666,2.265,2.265,0,0,0,.652-1.65,2.2,2.2,0,0,0-.666-1.636,2.265,2.265,0,0,0-1.65-.652,2.2,2.2,0,0,0-1.636.666,2.265,2.265,0,0,0-.652,1.65,2.2,2.2,0,0,0,.666,1.636A2.265,2.265,0,0,0,74.083,225.34Zm-2.315-8.517h4.6V199.634h-4.6ZM73.763,207.461Z",
    transform: "translate(1143 1133)",
    fill: "#a21110"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBig);
export default __webpack_public_path__ + "static/media/errorBig.3a45dc901dc2bdb98a595bc392adce05.svg";
export { ForwardRef as ReactComponent };